export default __webpack_public_path__ + "6203accbd049ef1d13fc50b79da8b0e8.gif";